import { booleanAttribute, Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'glxy-sticky-footer',
  templateUrl: './sticky-footer.component.html',
  styleUrls: ['./sticky-footer.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class StickyFooterComponent {
  @HostBinding('class') class = 'glxy-sticky-footer';

  @HostBinding('class.right-aligned')
  @Input({ transform: booleanAttribute })
  rightAligned = false;
}
